import React from "react";
import { DialogContent } from "@material-ui/core";
import { Dialog, DialogTitle } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import { CloseIcon } from "@icarius-icons";
import PaperDraggable from "@icarius-common/paperDraggable";
import DialogTransition from "@icarius-common/dialogTransition";
import CommonPage from "@icarius-common/commonPage";
import { getLocalizedString } from "@icarius-localization/strings";

const StyledDialog = withStyles({
  paper: {
    minWidth: "90%",
  },
})(Dialog);

const MyBenefitsHistoricalDialog = (props) => {

  const {
    open,
    data,
    handleClose,
  } = props;

  return (
    <StyledDialog
      TransitionComponent={DialogTransition}
      PaperComponent={PaperDraggable}
      open={open}
      scroll={"paper"}
      fullWidth={true}
      maxWidth={"md"}>
      <CloseIcon className={"dialog-close-icon icon"} onClick={handleClose} />
      <DialogTitle style={{ cursor: 'move', paddingBottom: 0 }} id="draggable-dialog-title">
        {getLocalizedString("myUsedBenefits")}
      </DialogTitle>
      <DialogContent>
        <CommonPage
          gridTitle={getLocalizedString("myUsedBenefits")}
          columnDefPage={"myBenefits/historical"}
          rowData={data}
          gridHeight={'70vh'}
          ignoreProcessesbyPath
          hasHelp
          hasExpand
        />
      </DialogContent>
    </StyledDialog>
  );
}

export default MyBenefitsHistoricalDialog;